import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import DataType from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Alert, Box, Grid, TextField, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MComptesRegroup';
import Demande from '../../../Models/McomptesPretEtDecouvert';
import Demande2 from '../../../Models/MComptesOperatSysteme';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import  { ColumnsType } from 'antd/es/table';
import DataPeriod1 from "../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataPeriod2 from "../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../Functions/Traitement/DataperiodMCompteRegpt4";
import CompteRegroupe from "../../../Models/CompteRegroup";
//import { IconButton, InputAdornment, Paper,  TablePagination, TableRow,TableBody, TableCell, TableContainer, TableHead } from '@mui/material';
import { IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import BlockIcon from '@mui/icons-material/Block';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CheckIcon from '@mui/icons-material/Check';
//import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import { normalizeKeysToUppercase } from "../../../utilitaires/globalFunction";
import { Check, CheckCircle } from "@mui/icons-material";
import McomptesPretEtDecouvert from "../../../Models/McomptesPretEtDecouvert";
import { maxHeaderSize } from "http";

//pour les commis
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const ComptesPretEtDecouvert = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [DataBranch, SetDataBranch] = useState<McomptesPretEtDecouvert[]>([]);
          const [currentDataBranch, setCurrentDataBranch] = useState<McomptesPretEtDecouvert | null>(null);
            
        const [searchTerm, setSearchTerm] = useState('');
            const [page, setPage] = useState(0); // Page actuelle
             const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
            const [error, setError] = useState<string | null>(null);
              const [loading2, setLoading2] = useState(false);
            const [choix, setChoix] = useState('I');
        
    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Compte de regroupement", value: "PLANCP" },
        { label: " Compte intérêts et commission", value: "IC" },
        { label: " Compte de prêts", value: "TYPEPRET" },
        { label: " Compte produit opération", value: "OPERAT" }
    ]

    //pour la selection de la table
    //let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: Ttable, Colonne1: Nnum, Colonne2: Colon, Colagence: '101', Choix: 22 }
    let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '', Choix: 22 }


  
    

  

    useEffect(() => {
         // setChoix('I');
          //alert('yetoo'+choix)
            loadAllDataBranch();
        }, [choix]);

        

    function Getselectcli() {
        setData([])
        form.setFieldValue("idplan", "")
        form.setFieldValue("lib_idplan", "")
            SetTtable("PLANCP")
            SetNnum("IDPLAN")
            setColon("LIBELL")
           // setColumn(columns1)

        // if (form.getFieldValue("categorie") == "PLANCP") {

        //     SetTtable("PLANCP")
        //     SetNnum("IDPLAN")
        //     setColon("LIBELL")
        //     setColumn(columns1)

        // } else if (form.getFieldValue("categorie") == "IC") {
        //     SetTtable("COMMIS")
        //     SetNnum("CODCOM")
        //     setColon("LIBELL")
        //     setColumn(columns2)
        // } else if (form.getFieldValue("categorie") == "TYPEPRET") {
        //     SetTtable("TYPEPRET")
        //     SetNnum("TYPEPRET")
        //     setColon("LIBELLE")
        //     setColumn(columns3)
        // } else if (form.getFieldValue("categorie") == "OPERAT") {
        //     SetTtable("OPERAT")
        //     SetNnum("CODOPE")
        //     setColon("LIBELL")
        //     setColumn(columns4)
        // } else {
        //     SetTtable("")
        //     SetNnum("")
        //     setColumn("")
        // }
    }

       // Fonction pour convertir un objet avec des clés en majuscules
   
    // 📄 Filtrage des données en fonction du terme de recherche
      const filteredDataBranch = DataBranch.filter((item) =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      // 📄 Pagination après filtrage
      const paginatedDataBranch = filteredDataBranch.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
    // --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
      const handleOpenDialog = (DataToEdit: McomptesPretEtDecouvert | null = null) => {
   //alert('modification'+DataToEdit?.UTILIS)
        if (DataToEdit) {
          setCurrentDataBranch({ ...DataToEdit }); // Copie pour l'édition
          
          form.setFieldsValue({...DataToEdit})
          setChoix('U')
         // HandleModif()
         // console.log(DataToEdit)
        } else {
          // Initialiser un nouvel objet avec des valeurs par défaut
      
        }
       // setOpenDialog(true);
       // setDialogError(null); // Réinitialiser les erreurs du dialogue
      };

      // --- valide un enregistrement ---
      const handleValidate = (DataToEdit: McomptesPretEtDecouvert | null = null) => {
       setChoix('V')
       if (DataToEdit) { setCurrentDataBranch({ ...DataToEdit })}; // Copie pour l'édition}
      
        if (currentDataBranch?.UTIVAL=== null || currentDataBranch?.UTIVAL=== undefined || currentDataBranch?.UTIVAL==="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
         var ComptesPretEtDecouvert: McomptesPretEtDecouvert = {
    IDTYPEPRET: currentDataBranch?.IDTYPEPRET || 0,
    TYPEPRET: currentDataBranch?.TYPEPRET || '', //currentDataBranch?.CODCOM || '';
    IDPLCPTINTIMP: currentDataBranch?.IDPLCPTINTIMP || '',
    IDPLCPTTVAIMP: currentDataBranch?.IDPLCPTTVAIMP || '',
    IDPLCPTINTPAIE: currentDataBranch?.IDPLCPTINTPAIE || '',
    IDPLCPTCOMPTAX: currentDataBranch?.IDPLCPTCOMPTAX || '',
    IDPLCPTPENPAIE: currentDataBranch?.IDPLCPTPENPAIE || '',
    IDPLCPTPROMESS: currentDataBranch?.IDPLCPTPROMESS || '',
    IDPLCPTGARAN: currentDataBranch?.IDPLCPTGARAN || '',
    IDPLCPTINTDOUT: currentDataBranch?.IDPLCPTINTDOUT || '',
    IDPLCPTTVADOUT: currentDataBranch?.IDPLCPTTVADOUT || '',
    IDPLCPTPROVCRDOUT: currentDataBranch?.IDPLCPTPROVCRDOUT || '',
    CODAGE: currentDataBranch?.CODAGE || '',
    
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: Perss.coduti,
    DATVAL: Perss.datjour,
    CHOIX: 'V',
    LIBELLE: '',
    
         };
       // alert('validation'+DataToEdit?.UTIVAL)
        // alert('validation'+DataToEdit?.UTIVAL)
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        //  CompteReg.choix = choix;
                     
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
       
          let data = Crypter.encrypt(JSON.stringify(ComptesPretEtDecouvert));
         if (window.confirm("Confirmer la validation des comptes de ce type de prêt?")) {
         
            // alert("yeteooo aaa")
            //alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                loadAllDataBranch()                 
            SweetAlert.fire({})
        // Action de validation ici
       //  console.log("Validé !");
  }
        } else {
          window.alert("Impossible de valider ce compte car il est déjà validé")
        }
      
      };
       // --- valide un enregistrement ---
      const handleDelete = (DataToEdit: McomptesPretEtDecouvert | null = null) => {
       setChoix('D')
     if (DataToEdit) { setCurrentDataBranch({ ...DataToEdit })}; // Copie pour l'édition}
 
        if (currentDataBranch?.UTIVAL!=="") {
         // window.alert("Impossible de supprimer ce compte car il est déjà validé")
    var ComptesPretEtDecouvert: McomptesPretEtDecouvert = {
    IDTYPEPRET: currentDataBranch?.IDTYPEPRET || 0,
    TYPEPRET: currentDataBranch?.TYPEPRET || '', //currentDataBranch?.CODCOM || '';
    IDPLCPTINTIMP: currentDataBranch?.IDPLCPTINTIMP || '',
    IDPLCPTTVAIMP: currentDataBranch?.IDPLCPTTVAIMP || '',
    IDPLCPTINTPAIE: currentDataBranch?.IDPLCPTINTPAIE || '',
    IDPLCPTCOMPTAX: currentDataBranch?.IDPLCPTCOMPTAX || '',
    IDPLCPTPENPAIE: currentDataBranch?.IDPLCPTPENPAIE || '',
    IDPLCPTPROMESS: currentDataBranch?.IDPLCPTPROMESS || '',
    IDPLCPTGARAN: currentDataBranch?.IDPLCPTGARAN || '',
    IDPLCPTINTDOUT: currentDataBranch?.IDPLCPTINTDOUT || '',
    IDPLCPTTVADOUT: currentDataBranch?.IDPLCPTTVADOUT || '',
    IDPLCPTPROVCRDOUT: currentDataBranch?.IDPLCPTPROVCRDOUT || '',
    CODAGE: currentDataBranch?.CODAGE || '',
    
    UTILIS: currentDataBranch?.UTILIS || '',
    DATCRE: currentDataBranch?.DATCRE?.toString() || new Date().toDateString(),
    UTIVAL: currentDataBranch?.UTIVAL || '',
    DATVAL: currentDataBranch?.DATVAL?.toString() || new Date().toDateString(),
    CHOIX:  'D',
    LIBELLE: '',

         };
        
          let data = Crypter.encrypt(JSON.stringify(ComptesPretEtDecouvert));
         if (window.confirm("Confirmer la suppression de ce compte de groupe?")) {
         
            // alert("yeteooo aaa")
            //alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            loadAllDataBranch()
           // SweetAlert.fire({})
        // Action de validation ici
        // console.log("Validé !");
  }
        } else {
          window.alert("Impossible de supprimer ce compte car il est déjà validé")
        }
      
      };
    
    
     
        async function loadAllDataBranch() {
          
             setLoading2(true);
            setError(null);
            try {
            
         // console.log(apiEndpoints.bureaux)
          var params = { CodeAgence: Perss.codage , Table: "ComptesTypepret", Colonne1: "typepret", Colonne2: "IDPLCPTINTPAIE", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
          console.log(params)
          const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
          
          if (data.length!==0)
             {
        // alter(data.result)
          //console.log(data)
          SetDataBranch(normalizeKeysToUppercase(data)); // ou console.log(data)
             }
            }catch (err) {
          console.error("Erreur de chargement:", err);
          setError("Impossible de charger les données .");
         } finally {
          setLoading2(false);
         }
        } ;
    
    // 🔁 Gestion du changement de page
      const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
      
      };
    
      // 🔁 Gestion du changement de nombre de lignes
      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Revenir à la première page après changement
      };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Génération comptes pret et découvert
                </span>
            ),
            children: <>
                <div className='tabItem' >

                <div style={{ display: 'block flow' }}  >
                     <Box 
                     sx={{
    width: '85%',
    maxWidth: '1300px',
    margin: '0 auto',
    position: 'absolute', // Remplacer absolute
    boxSizing: 'border-box',
    overflow: 'hidden', // Empêche les débordements visuels
  }}
                    //  fontStyle="inherit" className='border' width={"85%"} position={"absolute"} 
                      >

                            <legend style={{ textAlign: "center", paddingLeft: 10, borderRadius: 10 }} > Interface de Génération des comptes pret et découvert </legend>
                             <fieldset className="bordure1" style={{ marginTop: -20 }}>
                        <Box style={{ display: 'flex', flexWrap: 'wrap',  gap: '0', paddingLeft: 10 }}>
                    <Grid container spacing={0}>
    <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Type prêt"
      name="TYPEPRET"
      Taille1={'100%'}
      Parametre={searchPlancp}
      Taille2={'100%'}
      form={form}
    />
 
    </Grid>
    {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
      

    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte int impayé"
      name="IDPLCPTINTIMP"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
 

     </Grid>
     )}
     {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
   
     <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte tva impayé"
      name="IDPLCPTTVAIMP"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
  
     </Grid>
     )}
     {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
     
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte int payé"
      name="IDPLCPTINTPAIE"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />

     </Grid>
     )}

      {choix !== 'I' && (
     <Grid item xs={12} sm={6} >
  
      <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte TVA payée"
      name="IDPLCPTCOMPTAX"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
  
  
     </Grid>
     )}
     {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte pénalité"
      name="IDPLCPTPENPAIE"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
     </Grid>
      )}
       {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte promesse"
      name="IDPLCPTPROMESS"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
   
     </Grid>
     )}
      {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte garantie"
      name="IDPLCPTGARAN"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
     </Grid>
      )}
       {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte int douteux"
      name="IDPLCPTINTDOUT"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
     </Grid>
      )}
         {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte tva douteuse"
      name="IDPLCPTTVADOUT"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
     </Grid>
      )}
         {choix !== 'I' && (
     <Grid item xs={12} sm={6}  >
    <SearchModal
      disabled={false}
      width={0}
      Titre="Recherche"
      label="Compte provision douteuse"
      name="IDPLCPTPROVCRDOUT"
      Taille1={'100%'}
      Parametre={searchCompte}
      Taille2={'100%'}
      form={form}
    />
     </Grid>
      )}
                    </Grid>
                     </Box>

                            </fieldset>
                                <Box style={{ width: '100%', overflowX: 'auto' }}>
                                    <fieldset className="bordure1"  >
                                        {/* Zone de recherche */}
                                              <Box sx={{ mb: 2}}>
                                                <TextField
                                                  label="Recherche"
                                                  variant="outlined"
                                                  fullWidth
                                                  
                                                  value={searchTerm}
                                                   onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(0); // Remettre à la page 0 après recherche
                                                  }}
                                                  size="small"
                                                  InputLabelProps={{
                                                      sx: {
                                                        fontWeight: 'bold',
                                                              },
                                                             }}
                                                  InputProps={{
                                                     endAdornment: (
                                                     <InputAdornment position="end">
                                                     <SearchIcon color="action" />
                                                     </InputAdornment>
                                                                 ),
                                                             }}
                                                />
                                               
                                              </Box>
                                       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                         <TableContainer component={Paper} elevation={3} sx={{
                                              // --- Styles pour les ascenseurs ---
                                            //   maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                                            //   overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                                            //   overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                                            //   width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                                            //   //minWidth: '800', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                                            
                                              minWidth: 800, maxWidth: 'auto', mx: 'auto'
                                            }}>
                                          
                                                <Table stickyHeader sx={{ tableLayout: 'auto' }} >
                                              <TableHead  >
                                                <TableRow sx={{  height: 40, minHeight: 40, width:'auto', cursor: 'pointer' }}>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#116599", fontWeight:"bold",whiteSpace: 'nowrap'}}>Code  </TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#116599", fontWeight:"bold", whiteSpace: 'nowrap',}}>Agence </TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte int impaye</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold", whiteSpace: 'nowrap',}}>Cpte tva int impaye</TableCell>
                                                 <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte int payée</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte tva payée</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte penalité</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte promesse</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte garantie</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte int douteux</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte tva douteuse</TableCell>
                                                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Cpte prov douteuse</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Crée le</TableCell> 
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Crée par</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Validé le</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Validé par</TableCell>
                                                   <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #116599", fontWeight:"bold",whiteSpace: 'nowrap',}}>Actions</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {paginatedDataBranch.length === 0 ? (
                                                  <TableRow>
                                                    <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                                                  </TableRow>
                                                ) : (
                                                  paginatedDataBranch.map((item,index) => (
                                                   
                                                    <TableRow   key={`${item.TYPEPRET ?? 'no-id'}-${item.CODAGE ?? 'no-code'}-${item.IDTYPEPRET ?? 'no-cpt'}`} sx={{
                                                     cursor: 'pointer',
                                                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                                     '&:hover': {
                                                      // backgroundColor: '#e6f0f8', // Couleur au survol
                                                     // background: `linear-gradient(90deg, #0d4a70 0%, #116599 100%)`,
                                                      //color: '#fff', // Texte blanc sur fond sombre
                                                      background: 'linear-gradient(90deg, #eaf2fa 0%, #e0eef8 100%)',
                                                        },
                                                             }} >
                                                                 {/* Clé unique pour React */}
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.TYPEPRET}</TableCell>
                                                    <TableCell sx={{ py: 0 ,whiteSpace: 'nowrap'}}>{item.CODAGE ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTINTIMP ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTTVAIMP ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTINTPAIE ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0 ,whiteSpace: 'nowrap'}}>{item.IDPLCPTCOMPTAX ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTPENPAIE ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTPROMESS ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTGARAN ?? '—'}</TableCell>
                                                     <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTINTDOUT ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTTVADOUT ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.IDPLCPTPROVCRDOUT ?? '—'}</TableCell> 
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>                              
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.UTILIS ?? '—'}</TableCell>
                                                    <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.DATVAL ? new Date(item.DATVAL).toLocaleDateString(): '—'}</TableCell>
                                                     <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>{item.UTIVAL ?? '—'}</TableCell>
                                                     <TableCell sx={{ py: 0,whiteSpace: 'nowrap' }}>
                                                        <IconButton color="primary" onClick={() => {handleOpenDialog(item)}}>
                                                          <EditIcon />
                                                        </IconButton>
                                                        <IconButton color="success" onClick={() => {handleValidate(item)}}>
                                                          <Check/>
                                                        </IconButton>
                                                        <IconButton color="error" onClick={() => handleDelete(item)}>
                                                          <DeleteIcon />
                                                        </IconButton>
                                                      </TableCell>
                                                       {/* <TableCell sx={{ py: 0 }}>
                                                         <IconButton color="error" onClick={() => handleOpenDialog()}>
                                                          <DoneOutlineIcon />
                                                        </IconButton>
                                                       </TableCell> */}
                                                    </TableRow>
                                                  ))
                                                )}
                                              </TableBody>
                                              </Table>
                                              
                                            
                                        </TableContainer>
                                         {/* Pagination */}
                                              <TablePagination
                                                component="div"
                                                count={filteredDataBranch.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                labelRowsPerPage="Lignes par page"
                                              />
                                        </Box>    
                                        
                                    </fieldset>
                                 </Box>


                            <Box style={{ textAlign: "center", display: 'flex', marginTop: 15, marginLeft: 15 }} display={"-ms-grid"} fontStyle="inherit" >
                                {/* <Spin spinning={loading}>
                                    <Table dataSource={donnees} style={{ textAlign: "center", width: '98%' }} columns={Columm} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                </Spin> */}
                            </Box>
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];


    function consult() {



    }


    // function Onfinish
    const onFinish = (values: any) => {
        
    var compteCommis: McomptesPretEtDecouvert = values;
    compteCommis.IDTYPEPRET= currentDataBranch?.IDTYPEPRET || 0;
    compteCommis.TYPEPRET= form.getFieldValue("TYPEPRET") //currentDataBranch?.CODCOM || '';
    compteCommis.IDPLCPTINTIMP= form.getFieldValue("IDPLCPTINTIMP");
    compteCommis.IDPLCPTTVAIMP= form.getFieldValue("IDPLCPTTVAIMP");
    compteCommis.IDPLCPTINTPAIE= form.getFieldValue("IDPLCPTINTPAIE");
    compteCommis.IDPLCPTCOMPTAX= form.getFieldValue("IDPLCPTCOMPTAX");
    compteCommis.IDPLCPTPENPAIE= form.getFieldValue("IDPLCPTPENPAIE");
    compteCommis.IDPLCPTPROMESS= form.getFieldValue("IDPLCPTPROMESS");
    compteCommis.IDPLCPTGARAN= form.getFieldValue("IDPLCPTGARAN");
    compteCommis.IDPLCPTINTDOUT= form.getFieldValue("IDPLCPTINTDOUT");
    compteCommis.IDPLCPTTVADOUT= form.getFieldValue("IDPLCPTTVADOUT");
    compteCommis.IDPLCPTPROVCRDOUT= form.getFieldValue("IDPLCPTPROVCRDOUT");

    compteCommis.CODAGE= Perss.codage;
   
    compteCommis.UTILIS=  Perss.coduti;
    compteCommis.DATCRE= Perss.datjour;
    compteCommis.UTIVAL= Perss.coduti;
    compteCommis.DATVAL= Perss.datjour;
    compteCommis.CHOIX= choix;
     compteCommis.LIBELLE = '';
         
        // CompteReg.idcptregpt = currentDataBranch?.IDCPTREGPT ||0;//CompteReg.idcptregpt;
        // CompteReg.idplan =  form.getFieldValue("IDPLAN") //CompteReg.idplan;
        //  CompteReg.codage = Perss.codage;
        // CompteReg.cptregpt = form.getFieldValue("CPTREGPT") //CompteReg.cptregpt;
        // CompteReg.utilis = Perss.coduti;
        // CompteReg.datcre=Perss.datjour;
        // CompteReg.utival=Perss.coduti;
        // CompteReg.datval=Perss.datjour
        //  CompteReg.choix = choix;                    
        // CompteReg.libelle = form.getFieldValue("NOMCPT") //CompteReg.libelle;
        // //CompteReg.nomcpt = choix;
        let data = Crypter.encrypt(JSON.stringify(compteCommis));
        
        // ************* pour le consult 
        if (sbmit == 'Consult') {
            loadAllDataBranch();           
            // ************* mis a jour  *********************
        } else if (sbmit=='Enreg'){
            // alert("yeteooo aaa")
           // alert(data)
            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
            SweetAlert.fire({})
      
        } else if (sbmit=='Add'){
           // alert("modif")
                if (form.getFieldValue("IDPLAN") != "") {
                            setLoading(true)
                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.CreateCptTypepret,
                                headers: {
                                    'CypherGpt': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };
                            axios.request(config)
                                .then((response) => {
                                    setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
                                            if (code == 'Introuvable') {
                                                SweetAlert.fire({ title: "Warning", text: "Le Plan Comptable n'existe Pas", icon: "warning" })
                                            } else if (code == 'Existe') {
                                                SweetAlert.fire({ title: "Warning", text: 'Operation Impossible: il posséde déja des comptes contre-partie ', icon: "warning" })
                                            } else {
                                                setIsSubmit(false)
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                    setLoading(false)
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                });
                        }else {
                            SweetAlert.fire({ title: "Warning", text: "Veuillez remplir le champ Plan Comptable", icon: "warning" })
                        }
        }
    }
    


    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir le champs obligatoire", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir le champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                {/* <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}> */}
                 <Form disabled={!FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish}  style={{ minWidth: 'auto', maxWidth: 'auto' }}>

                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { setSbmit("Consult") }} type="ghost" htmlType="submit" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { setSbmit("Add") ;setChoix('I')}} type="ghost" htmlType="submit" block>
                                    Générer
                                </Button>
                                <Button size='large' disabled={false} onClick={() => {setSbmit("Enreg") ;setChoix('U')}} className='bt_add' type="ghost" htmlType="submit" block>
                                    Mise à jour
                                </Button>
                                <Button size='large' disabled={false} onClick={() => { form.resetFields(); setData([]); SetTtable(""); SetNnum(""); setColumn("");setChoix('I') }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ComptesPretEtDecouvert;